'use client';

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ToastProvider } from '@/contexts/toastProvider';
import { type ReactNode, useState } from 'react';
import { AuthUserProvider } from '@/contexts/authUserContext';

export default function Providers({ children }: { children: ReactNode }) {
  // // Create a new QueryClient instance for each session
  // const [queryClient] = useState(
  //   () =>
  //     new QueryClient({
  //       defaultOptions: {
  //         queries: {
  //           staleTime: 5 * 60 * 1000, // 5 minutes
  //           refetchOnWindowFocus: false,
  //           retry: 1,
  //         },
  //       },
  //     })
  // );

  return (
    <ToastProvider>
      <AuthUserProvider>
        {/* <QueryClientProvider client={queryClient}> */}
          {children}
        {/* </QueryClientProvider> */}
      </AuthUserProvider>
    </ToastProvider>
  );
}
